import { queryOptions, useQuery } from '@tanstack/react-query';
import { LoopPlannerTimelineItemsApi } from '@/lib/api/loop-planner/timeline-items';
import { loopPlannerQueryKeys } from '@/lib/query-keys/loop-planner';

export const bulkFetchTimelineItemsQueryOptions = ({
  loopId,
  scenarioId,
  itemIds,
  enabled = true,
  staleTime,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
  enabled?: boolean;
  staleTime?: number;
}) =>
  queryOptions({
    queryKey: loopPlannerQueryKeys.timelineItems.bulkFetch({ loopId, scenarioId, itemIds }),
    queryFn: () => LoopPlannerTimelineItemsApi.bulkFetch({ loopId, scenarioId, itemIds }),
    enabled: enabled && itemIds.length > 0,
    ...(staleTime !== undefined && { staleTime }),
  });

export const useBulkFetchTimelineItems = ({
  loopId,
  scenarioId,
  itemIds,
  enabled,
  staleTime,
}: {
  loopId: number;
  scenarioId: number;
  itemIds: number[];
  enabled?: boolean;
  staleTime?: number;
}) => {
  return useQuery(
    bulkFetchTimelineItemsQueryOptions({ loopId, scenarioId, itemIds, enabled, staleTime }),
  );
};
